module.exports = __webpack_public_path__ + "static/media/ai-tutorial-group-qrcode.e01a6e60.png";